import { RETAILER_REPORTS_TAB } from "../../framework/tab/tabUtilsConstants";

export const initial_state_retailer_report = {
  type: RETAILER_REPORTS_TAB,
  label: "Retailer",
  allowMultipleTabs: false,
};

export const columnDefs = [
  {
    headerName: "Branch Code",
    field: "code",
    flex: 1,
  },
  {
    headerName: "Shop name",
    field: "name",
    flex: 1,
  },
  {
    headerName: "Address",
    field: "address",
    flex: 1,
  },
  {
    headerName: "Drug License",
    field: "ttl",
    flex: 1,
  },
  {
    headerName: "Telephone Number",
    field: "ttl",
    flex: 1,
  },
];

export const columnDefsFunctions = {};
